module.exports = __webpack_public_path__ + "static/media/1.a46d92f0.svg";